// test366
(366 && 0);
